import { AnimatePresence } from "motion/react";
import { FC, useState } from "react";
import useEvent from "react-use-event-hook";

import { SVG_MUI } from "@ryde/assets";
import { useReportId } from "@ryde/redux";
import { IReportTemplateItemTranslated } from "@ryde/shared";

import { ReportNavigationItem } from "./report-navigation.item";
import {
  ReportNavigationGroupContainerStyled,
  ReportNavigationGroupHeaderStyled,
} from "./report-navigation.styled";

interface IReportNavigationGroupHeader {
  groupTitle: string;
  collapsed?: boolean;
  toggleCollapse: () => void;
}

const ReportNavigationGroupHeader: FC<IReportNavigationGroupHeader> = ({
  groupTitle,
  collapsed,
  toggleCollapse,
}) => {
  return (
    <ReportNavigationGroupHeaderStyled onClick={() => toggleCollapse()}>
      {groupTitle}
      {!collapsed && (
        <SVG_MUI.ChevronDownSVG
          className="collapse_toggle"
          title="Collapse grouping"
        />
      )}
      {!!collapsed && (
        <SVG_MUI.ChevronUpSVG
          className="collapse_toggle"
          title="Collapse grouping"
        />
      )}
    </ReportNavigationGroupHeaderStyled>
  );
};

export const ReportNavigationGroup: FC<IReportTemplateItemTranslated> = ({
  titleTranslated,
  items,
}) => {
  const [collapsed, setCollapsed] = useState(false);
  const { reportId } = useReportId();
  const toggleCollapse = useEvent(() => {
    setCollapsed(!collapsed);
  });
  return (
    <ReportNavigationGroupContainerStyled>
      <ReportNavigationGroupHeader
        toggleCollapse={toggleCollapse}
        collapsed={collapsed}
        groupTitle={titleTranslated || ""}
      />
      <AnimatePresence>
        {!collapsed &&
          items?.map(x => (
            <ReportNavigationItem
              key={x.id}
              active={reportId === x.id}
              {...x}
            />
          ))}
      </AnimatePresence>
    </ReportNavigationGroupContainerStyled>
  );
};
